import Vue from 'vue'

Vue.directive('truncate', function (el, binding) {
	el.classList.add('truncated')
	el.title = el.textContent
})
